import './PermissionError.css';
import Grid from '@mui/material/Grid';
import Anchor from '../../elements/Anchor';
import url_link from '../../../assets/url_links';
import logo from '../../../assets/images/QuidelOrtho-logo-indigo.png';

const PermissionError = () => {
    return (
        <div className='error-container'>
            <Grid container direction="column" rowSpacing={2}>
                <Grid item style={{ textAlign: 'left' , marginLeft: '2vw'}}>
                    <div>
                        <img src={logo} alt="QuidelOrtho Logo" style={{ width: '150px', height: 'auto' }} />
                    </div>
                </Grid>
                <Grid item>
                    <div className='error-conatiner'>
                        <p className='error-text'>Permission Error</p>
                        <p>We're sorry, you don't have permission to this area of our site. Please contact your administrator to be granted access.</p>
                    </div>
                </Grid>
                <Grid item>
                    <div className='footer-conainter'>

                        <div className='footer-links'>

                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                alignItems="flex-start"
                            >

                                <Grid item>
                                    <Anchor url={url_link.permissionErr.employee_notice}>Employee Notice</Anchor>
                                </Grid>
                                <Grid item>
                                    <Anchor url={url_link.permissionErr.legal_notice}>Legal Notice</Anchor>
                                </Grid>
                                <Grid item>
                                    <Anchor url={url_link.permissionErr.cookie_notice}>Cookie Notice & Disclosuree</Anchor>
                                </Grid>

                                <Grid item>
                                    <Anchor url={url_link.permissionErr.ca_odc_notice}>Declaration for California Compliance</Anchor>

                                </Grid>

                            </Grid>
                        </div>

                        <p>© QuidelOrtho 2026. This site is published by QuidelOrtho, which is solely responsible for its contents. Product availability is subject to fulfillment of regulatory requirements in each market.</p>
                    </div>
                </Grid>
            </Grid>


        </div>
    )
}

export default PermissionError;